export default __webpack_public_path__ + "static/media/play_button.ff00a028.png";